
//选中查询的日期类型，查询日数据、月数据
export const ALARM_MASKCHOOSETYPE_SEARCH_TYPE='ALARM/MASKCHOOSETYPE/SEARCH_TYPE';
//选中查询的日期时间
export const ALARM_MASKCHOOSETYPE_YEAR_SEARCH_DATE='ALARM/MASKCHOOSETYPE/YEAR/SEARCH_DATE';
